export class ProFunnelModel {
    id: number = 0;
    companyName: string = "";
    companyCode: string = "";
    companyType: number = 0;
    companyGrade: string = "";
    companyState: string = "";
    contactName: string = "";
    contactEmail: string = "";
    contactPhone: string = "";
    companyBadge: string = "Manage";
    comment: string = "";
    totalDoc: number = 0;
    totalCp: number = 0;
    cpPageView: number = 0;
    companyIsShowProfile: boolean;
    companyIsObsolete: boolean;
    lastRefresh: string;
    packageTotal: number = 0;
    packageAmount: number = 0;
    remainingProject: number = 0;
    projActiveTotal: number = 0;
}
